import GenericCatalogPage from "./GenericCatalogPage";
import { Microscope } from "lucide-react";

export default function Methods() {
  return (
    <GenericCatalogPage
      title="Métodos"
      description="Administre los métodos de análisis"
      icon={Microscope}
      apiKey="methods"
      testIdPrefix="method"
    />
  );
}
